const translations = {
    applicatorCertificationNumber: 'Applicator certification no.',
    businessAddress: 'Business address',
    businessLicenseeAndApplicator: 'Business (Licensee) and Applicator',
    businessName: 'Business name',
    certificationCategory: 'Certification category',
    certificationExpiration: 'Certification expiration',
    certifiedApplicator: 'Certified applicator',
    licenseExpiration: 'License expiration',
    pesticideBusinessLicenseNumber: 'Pesticide business license no.'
};

export default translations;
